export function appendDash(str: string) {
  return ` - ${str}`
}
